@if (uploadType === 'drag') {
<nz-upload
  nzType="drag"
  [nzMultiple]="multiple"
  [nzLimit]="maxLength"
  [nzAccept]="accept"
  [nzDisabled]="!!maxLength && fileList && maxLength <= fileList.size"
  [nzAction]="actionUrl"
  [nzFileListRender]="fileListPreview"
  (nzChange)="change($event)"
  [(nzFileList)]="list"
>
  <un-icon
    class="c-secondary upload"
    type="cloud-upload"
    theme="outline"
  ></un-icon>
  <p i18n="@@clickOrDragAndDropFile">Click or drag and drop file</p>
  @if (accept) {
  <p class="c-soft t-small" i18n="@@filesSupportedAre">
    Files supported are {{ accept | uppercase }}
  </p>
  } @if (recommendedSize) {
  <p class="c-secondary t-small" i18n="@@recommendedSize">
    Recommended size: {{ recommendedSize.join(' x ') }}
  </p>
  } @if (maxLength) {
  <p class="c-secondary" i18n="@@maxFiles">Max files: {{ maxLength }}</p>
  }
</nz-upload>
}

<ng-template #fileListPreview>
  <div class="files-wrapper">
    @for (file of fileList?.values(); track file) {
    <div class="file" [ngClass]="size">
      @if (file | file | async; as f) {
      <un-file-preview
        [file]="f"
        [height]="128"
        [width]="128"
      ></un-file-preview>
      }
      <div class="info">
        <div class="file-info t-small">
          <div class="text">
            @if (file?.name) {
            <p class="t-ellipsis">
              {{ file.name }}
            </p>
            } @if (file?.size) {
            <p class="c-soft">{{ file.size | fileSize }}</p>
            }
          </div>
          <un-icon
            type="delete"
            theme="outline"
            (click)="delete(file.src)"
          ></un-icon>
        </div>
        <!-- Select -->
        @if (size === 'large') {
        <nz-select
          [ngModel]="file.documentType"
          nzPlaceHolder="Choose file type"
          [nzShowArrow]="true"
          [nzOptions]="documentTypes"
          (ngModelChange)="updateDocumentType(file, $event)"
        ></nz-select>
        }
      </div>
    </div>
    }
  </div>
</ng-template>

@if (uploadType === 'photo') {
<div class="clearfix">
  <nz-upload
    [nzAction]="actionUrl"
    nzListType="picture"
    [nzMultiple]="false"
    [nzAccept]="accept"
    [nzPreview]="handlePreview"
    [nzFileListRender]="nothing"
    (nzChange)="change($event)"
    [(nzFileList)]="list"
  >
    @for (file of fileList?.values(); track file) {
    <div class="photo-card" [ngClass]="size">
      @if (file | file | async; as f) {
      <un-file-preview
        [file]="f"
        [ngClass]="{rounded}"
        [height]="128"
        [width]="128"
      ></un-file-preview>
      }
      <un-button size="small" i18n="@@change">Change</un-button>
    </div>
    } @if (fileList?.size === 0) {
    <div class="photo-card">
      <un-icon type="picture" theme="fill" [ngClass]="{rounded}"></un-icon>
      <un-button size="small" i18n="@@upload">Upload</un-button>
    </div>
    }
  </nz-upload>
  <nz-modal
    [nzVisible]="previewVisible"
    [nzContent]="modalContent"
    [nzFooter]="null"
    (nzOnCancel)="previewVisible = false"
  >
    <ng-template #modalContent>
      <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
    </ng-template>
  </nz-modal>
</div>
} @if (uploadType === 'icon') {
<nz-upload
  [nzAction]="actionUrl"
  nzListType="picture"
  [nzMultiple]="multiple"
  [nzAccept]="accept"
  [nzPreview]="handlePreview"
  [nzFileListRender]="nothing"
  (nzChange)="change($event)"
  [(nzFileList)]="list"
  [nzLimit]="maxLength"
>
  <nz-badge [nzCount]="fileList.size">
    <un-icon
      type="paper-clip"
      theme="outline"
      class="c-secondary t-large"
    ></un-icon
  ></nz-badge>
</nz-upload>
}
<ng-template #nothing></ng-template>
